module.exports = __webpack_public_path__ + "img/chrome10.8011b2a3.png";